import styled from "styled-components";

export const BoxTurnoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  ${({ $ultimoPaso, $minResolucion }) => {
    if ($ultimoPaso) {
      if ($minResolucion) {
        return `
        padding: 0 0 200px 0;
      `;
      } else {
        return `
          padding: 0 0 400px 0;
        `;
      }
    }
  }}
  .linearda {
    position: relative;
    top: 10px;
    left: 50px;
  }
  .conta,
  .conta2 {
    display: flex;
    align-items: center;
    /* gap: 20px; */
  }
  .conta2 {
    margin-left: 4px;
  }
`;

export const BuscadorTurnosContainer = styled.div`
  margin-left: 24px;
  width: 90%;
  height: auto;
  border-radius: 8px;
  background: var(--color-buscadorCards-gradient);

  box-shadow:
    0px 2.76726px 2.21381px 0px rgba(0, 0, 0, 0.02),
    0px 6.6501px 5.32008px 0px rgba(0, 0, 0, 0.03),
    0px 12.52155px 10.01724px 0px rgba(0, 0, 0, 0.04),
    0px 22.33631px 17.86905px 0px rgba(0, 0, 0, 0.04),
    0px 41.77761px 33.42209px 0px rgba(0, 0, 0, 0.05),
    0px 100px 80px 0px rgba(0, 0, 0, 0.07);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 30px;
  padding: 30px 16px;
  z-index: 5;
  @media (max-width: 1680px) {
    /* width: 1050px; */
  }
`;

export const BuscadorTurnosContainer2 = styled(BuscadorTurnosContainer)`
  z-index: 4;
  ${({ $show }) => {
    if ($show) {
      return `
        transition: transform 0.5s ease;
        transform: translateY(0px);
        opacity: 100%;
      `;
    } else {
      return `
        transition: transform 0.5s ease;
        transform: translateY(-200px);
        opacity: 0%;
        visibility: hidden;
      `;
    }
  }}
`;

export const BuscadorTurnosContainer3 = styled(BuscadorTurnosContainer)`
  z-index: 3;
  gap: 10px;

  ${({ $show }) => {
    if ($show) {
      return `
        transition: transform 0.5s ease;
        transform: translateY(0px);
        opacity: 100%;
      `;
    } else {
      return `
        transition: transform 0.5s ease;
        transform: translateY(-184px);
        opacity: 0%;
        visibility: hidden;
      `;
    }
  }}
`;

export const BuscadorTurnosContainer4 = styled(BuscadorTurnosContainer)`
  z-index: 2;
  /* gap: 20px; */
  height: auto;
  gap: 10px;
  /* justify-content: space-between; */
  ${({ $show }) => {
    if ($show) {
      return `
        transition: transform 0.5s ease;
        transform: translateY(0px);
        opacity: 100%;
      `;
    } else {
      return `
        transition: transform 0.5s ease;
        transform: translateY(-360px);
        opacity: 0%;
        visibility: hidden;
      `;
    }
  }}
`;

export const TurnoSeleccionadoBtnContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PreguntaBox = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
`;

export const PresentismoIconBox = styled.div`
  width: auto;
  cursor: pointer;
`;

export const BuscadorBtnContainer = styled.div`
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  align-items: center;
  ${({ $centrado }) => {
    if ($centrado) {
      return `
        justify-content: center;
      `;
    }
  }}
`;
export const OtrosTurnosContainer = styled.div`
  display: flex;
  gap: 30px;
  margin-top: 20px;
  align-items: center;
  justify-content: center;
`;

export const BuscadorBtn = styled.button`
  width: 170px;
  padding: 8px;
  min-height: 46px;
  border-radius: 8px;
  position: relative;
  ${({ $activo, $sinPermiso }) => {
    if ($sinPermiso) {
      return `
        background: rgba(255, 255, 255, 0.15);
        opacity: 0.65;
        border: 1px dashed rgba(255, 255, 255, 0.5);
      `;
    } else if ($activo) {
      return `
        background: var(--color-primary);
      `;
    } else {
      return `
        background: #B55516;
      `;
    }
  }}
`;
export const TurnoBtn = styled(BuscadorBtn)`
  width: 362px;
  height: auto;
  min-height: 46px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
export const BuscarBtn = styled.button`
  width: 362px;
  padding: 2px;
  border: 2px solid white;
  height: 46px;
  border-radius: 8px;
  /* background: transparent; */
  ${({ $activo }) => {
    if ($activo) {
      return `
        background: var(--color-latex10);
      `;
    } else {
      return `
        background: transparent;
      `;
    }
  }}
`;

export const OrdenContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;
export const TextoOrdenContainer = styled.div`
  width: 48%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  .subTxt {
    width: 66vh;
  }
  @media (max-width: 1280px) {
    width: 76%;
  }
`;

export const OrdenBtn = styled.button`
  width: 182px;
  height: 36px;
  border-radius: 8px;
  border: 2px solid #fff;
  background: transparent;
  cursor: pointer;
`;

export const BuscadorContainer = styled.div`
  position: relative;
  padding: 0px 20px 28px 20px;
  border-radius: 8px;
  z-index: 10;
  /* min-width: 960px; */
  display: flex;
  align-items: flex-end;
  .ptur-buscadorTurnos-dropdown {
    width: 568px;
  }
`;

export const FormatoFechaBox = styled.div`
  display: flex;
  gap: 36px;
  @media (max-width: 1024px) {
    gap: 0px;
    flex-direction: column;
  }
`;

export const FormatoBox = styled.div`
  display: flex;
  flex-direction: column;
  width: max-content;
  @media (max-width: 1680px) {
    gap: 8px;
  }
  @media (max-width: 1024px) {
    gap: 0px;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  .ptur-buscadorTurnos-checkbox-consultaMedica {
    height: 30px;
    padding-top: 8px;
    margin-left: 24px;
  }
  @media (max-width: 1680px) {
    flex-direction: column;
  }
  @media (max-width: 1024px) {
    gap: 24px;
    flex-direction: row;
    .ptur-buscadorTurnos-checkbox-consultaMedica {
      margin: 0;
    }
  }
`;

export const TituloCheckbox = styled.div`
  padding-top: 13px;
  margin-left: 24px;
`;

export const FechaBotonContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 22px;
  margin-top: 16px;
  .ptur-buscadorTurnos-fecha {
    width: 140px;
  }
  .ptur-datePicker-buscadorTurnos {
    margin-bottom: 10px;
  }
  @media (max-width: 1680px) {
    display: unset;
  }
  @media (max-width: 1024px) {
    display: flex;
    align-items: center;
    gap: 24px;
    margin-top: 24px;
  }
  @media (max-width: 1020px) {
    .ptur-datePicker-buscadorTurnos {
      margin-bottom: 0px;
    }
  }
`;

export const BtnSiguienteBox = styled.div`
  margin-bottom: 8px;
  max-height: 42px;
  @media (max-width: 1680px) {
    margin-bottom: 8px;
  }
  @media (max-width: 1024px) {
    margin-top: 34px;
  }
`;

export const BtnSiguiente = styled.button`
  width: 142px;
  height: 42px;
  max-height: 42px;
  padding: 12px;
  border-radius: 8px;
  position: relative;
`;

export const BtnLoading = styled.span`
  position: absolute;
  top: 8px;
  left: 59px;
`;

export const ErrorPermisoBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;
